import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Button, ListGroup, ListGroupItem, Tooltip } from 'reactstrap';
import MaterialIcon from "material-icons-react";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import i18n from "../../../../i18next";
import {
    loadDeliverySettings,
    updateDeliverySettings,
    updateDeliveryZones,
    deleteDeliveryZone,
    resetDeliverySettings,
    dispatchErrorMessage,
    loadRestaurant,
    getDeliveryPartners
} from '../../../../actions/index';
import { convertCheckBoxValueToBoolean, getCurrencySymbol } from '../../../../utils/CommonUtils';
import Map from './Map';
import DeliveryZoneItem from './DeliveryZoneItem';
import DeliveryZoneConfirmationScreen from './DeliveryZoneConfirmationScreen';

const INITIAL_BLANK_ZONE_STATE = {
    name: 'New Delivery Zone',
    deliveryTime: null,
    deliveryCharge: null,
    deliveryChargeInPercentage: false,
    minimumOrderAmount: 1,
    maximumOrderAmount: '',
    active: true,
    zipCodes: '',
    verticesCoordinates: [],
    removeLargeMap: false,
    color: 'GRAY',
    deliveryZoneCircleRange: {
        measureUnit: null,
        startRange: null,
        endRange: null,
    }
};

class DeliveryZonesScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: null,
            zoneType: null,
            newZoneType: null,
            deliveryZones: null,
            map: null,
            polygons: [],
            currentDeliveryZone: null,
            stateAlreadyCopiedFromProps: false,
            tooltipOpen: false,
            displayNewZone: false,
            blankDeliveryZone: {
                name: 'New Delivery Zone',
                deliveryTime: null,
                deliveryCharge: null,
                deliveryChargeInPercentage: false,
                minimumOrderAmount: 1,
                maximumOrderAmount: '',
                active: true,
                zipCodes: '',
                verticesCoordinates: null,
                color: 'GRAY',
                deliveryZoneCircleRange: {
                    measureUnit: null,
                    startRange: null,
                    endRange: null,
                }
            },
            confirmationScreenOpened: false,
            itemConfirmationScreenOpened: false,
            previousDeliveryZone: null,
            scrollToElement: null
        };

        this.handleZoneTypeUpdate = this.handleZoneTypeUpdate.bind(this);
        this.changeDeliveryZoneType = this.changeDeliveryZoneType.bind(this);
        this.changeDeliveryZoneState = this.changeDeliveryZoneState.bind(this);
        this.updateCurrentDeliveryZone = this.updateCurrentDeliveryZone.bind(this);
        this.deleteDeliveryZone = this.deleteDeliveryZone.bind(this);
        this.deleteNewDeliveryZone = this.deleteNewDeliveryZone.bind(this);
        this.toggleNewDeliveryZone = this.toggleNewDeliveryZone.bind(this);
        this.changeBlankDeliveryZoneState = this.changeBlankDeliveryZoneState.bind(this);
        this.createNewDeliveryZone = this.createNewDeliveryZone.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.toggleConfirmationScreen = this.toggleConfirmationScreen.bind(this);
        this.toggleItemConfirmationScreen = this.toggleItemConfirmationScreen.bind(this);
        this.drawCircle = this.drawCircle.bind(this);
    }

    copyStateFromProps() {
        if (this.props.deliverySettings !== undefined && this.props.deliverySettings !== null && this.props.deliverySettings.id !== undefined
            && (!this.state.stateAlreadyCopiedFromProps || this.props.deliverySettings.id !== this.state.id)) {

            this.setState({
                id: this.props.deliverySettings.id,
                deliveryZones: this.props.deliverySettings.deliveryZones,
                preparationTimes: this.props.deliverySettings.preparationTimes,
                supportedTenderTypes: this.props.deliverySettings.supportedTenderTypes,
                minimumOrderAmount: this.props.deliverySettings.minimumOrderAmount,
                maximumOrderAmount: this.props.deliverySettings.maximumOrderAmount,
                stateAlreadyCopiedFromProps: true,
                zoneType: this.props.deliverySettings.zoneType
            });
        }
    }

    componentWillUnmount() {
        this.props.resetDeliverySettings();
    }

    componentDidMount() {
        const restaurantId = this.props.match.params.id;
        this.props.loadDeliverySettings(restaurantId);
        this.props.loadRestaurant(restaurantId);
        this.props.getDeliveryPartners();
    }

    componentDidUpdate() {
        // Scroll the element into view
        if (this.state.scrollToElement) {
            this.state.scrollToElement.scrollIntoView({ behavior: "smooth" })
        }
    }

    centerMapOnRestaurantCity(map) {

        if (map) {
            let country = this.props.restaurant.address.country;
            let city = this.props.restaurant.address.city;
            let restaurantAddress = String(city) + ' , ' + String(country);

            let geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ 'address': restaurantAddress }, (results, status) => {
                if (status === window.google.maps.GeocoderStatus.OK) {
                    map.setCenter(results[0].geometry.location);
                    map.fitBounds(results[0].geometry.bounds);
                } else {
                    this.props.dispatchErrorMessage(i18n.t('screens:deliveryZoneItem.alertGeocodeMsg'));
                }
            });
        }

    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    toggleNewDeliveryZone() {
        this.setState({
            displayNewZone: !this.state.displayNewZone
        });
    }

    toggleConfirmationScreen(cancelClicked) {
        this.setState({
            confirmationScreenOpened: !this.state.confirmationScreenOpened,
        });
    }

    toggleItemConfirmationScreen() {
        this.setState({
            itemConfirmationScreenOpened: !this.state.itemConfirmationScreenOpened
        });
    }

    addDeliveryZonesToMap(map) {

        if (map) {
            let bounds = new window.google.maps.LatLngBounds();
            if (this.state.deliveryZones !== null && this.state.deliveryZones.length !== 0) {
                // Populate the map with the zones
                if (this.state.zoneType === 'MAP_BASED') {
                    this.state.deliveryZones.forEach((deliveryZone) => {
                        if (deliveryZone.verticesCoordinates.length) {

                            // Format the coordinates in the correct format for the google maps api
                            let formattedCords = [];

                            deliveryZone.verticesCoordinates.map((cord) => {
                                let formattedCord = { lat: cord.latitude, lng: cord.longitude };
                                formattedCords.push(formattedCord);
                            });

                            let currentZone = new window.google.maps.Polygon({
                                paths: formattedCords,
                                strokeColor: deliveryZone.color,
                                strokeOpacity: 0.6,
                                strokeWeight: 3,
                                fillColor: deliveryZone.color,
                                fillOpacity: 0.35
                            });

                            currentZone.setMap(map);

                            this.setState({ polygons: this.state.polygons.concat(currentZone) });

                            // Add current Zone cords to map bounds so the map zoom to bounds
                            for (let i = 0, l = formattedCords.length; i < l; i++) {
                                bounds.extend(formattedCords[i]);
                            }
                        }
                    });
                } else if (this.state.zoneType === 'CIRCLE_BASED') {
                    this.state.deliveryZones.forEach((deliveryZone) => {
                        if (deliveryZone.deliveryZoneCircleRange) {
                            let centerLat = this.props.restaurant.address.latitude;
                            let centerlng = this.props.restaurant.address.longitude;
                            let start = deliveryZone.deliveryZoneCircleRange.startRange;
                            let end = deliveryZone.deliveryZoneCircleRange.endRange;

                            let circleZone = new window.google.maps.Polygon({
                                paths: [this.drawCircle(new window.google.maps.LatLng(centerLat, centerlng), end, 1, deliveryZone.deliveryZoneCircleRange.measureUnit, bounds),
                                this.drawCircle(new window.google.maps.LatLng(centerLat, centerlng), start, -1, deliveryZone.deliveryZoneCircleRange.measureUnit, bounds)],
                                strokeColor: deliveryZone.color,
                                strokeOpacity: 0.6,
                                strokeWeight: 3,
                                fillColor: deliveryZone.color,
                                fillOpacity: 0.35
                            });



                            circleZone.setMap(map);
                            this.setState({ polygons: this.state.polygons.concat(circleZone) });
                        }
                    });
                }
            }
            // If no bounds from deliveryZones zoom the map on the City
            if (bounds.isEmpty()) {
                this.centerMapOnRestaurantCity(map);
            }

            map.fitBounds(bounds);

            // Control the zoom of the map
            let listener = window.google.maps.event.addListener(map, "idle", function () {
                if (map.getZoom() > 16) map.setZoom(12);
                window.google.maps.event.removeListener(listener);
            });
        }
    }

    changeDeliveryZoneType({ target }) {
        let newZone = null;
        target.name === 'mapping' && (newZone = 'MAP_BASED');
        target.name === 'zipCodes' && (newZone = 'ZIP_CODE_BASED');
        target.name === 'circleRule' && (newZone = 'CIRCLE_BASED');

        this.setState({
            ...this.state,
            confirmationScreenOpened: true,
            newZoneType: newZone
        });
    }

    changeDeliveryZoneState({ target }) {
        const deliveryZoneId = Number(target.id);
        if (target.value === 'true' || target.value === true || target.value === 'false' || target.value === false) {
            target.value = convertCheckBoxValueToBoolean({ target });
        }

        let updatedDeliveryZones = this.updateDeliveryZones(target, deliveryZoneId);

        let currentDeliveryZone = updatedDeliveryZones.filter((deliveryZone) => {
            return deliveryZone.id === deliveryZoneId;
        });

        this.setState({
            ...this.state,
            deliveryZones: updatedDeliveryZones,
            currentDeliveryZone: currentDeliveryZone
        });
    }

    changeBlankDeliveryZoneState({ target }) {
        if (target !== undefined && target !== null) {
            if (target.name == 'deliveryChargeInPercentage' || target.name == 'active') {
                this.setState({
                    blankDeliveryZone: {
                        ...this.state.blankDeliveryZone,
                        [target.name]: convertCheckBoxValueToBoolean({ target })
                    }
                });
            } else if (target.name === 'measureUnit' || target.name === 'startRange' || target.name === 'endRange') {
                this.setState({ ...this.state, blankDeliveryZone: { ...this.state.blankDeliveryZone, deliveryZoneCircleRange: { ...this.state.blankDeliveryZone.deliveryZoneCircleRange, [target.name]: target.value } } } )
            } else {
                this.setState({
                    blankDeliveryZone: {
                        ...this.state.blankDeliveryZone,
                        [target.name]: target.value
                    }
                });
            }
        }
    }

    updateDeliveryZones(target, deliveryZoneId) {
        const updatedDeliveryZones = [];

        this.state.deliveryZones.map(item => {
            const currentDeliveryZone = {
                id: Number(item.id),
                name: item.name,
                deliveryTime: (item.deliveryTime !== '') ? Number(item.deliveryTime) : item.deliveryTime,
                deliveryCharge: item.deliveryCharge,
                deliveryChargeInPercentage: Boolean(item.deliveryChargeInPercentage),
                minimumOrderAmount: (item.minimumOrderAmount !== '') ? Number(item.minimumOrderAmount) : item.minimumOrderAmount,
                maximumOrderAmount: (item.maximumOrderAmount !== '' && item.maximumOrderAmount !== null) ? parseInt(item.maximumOrderAmount) : '',
                active: item.active,
                zipCodes: item.zipCodes,
                verticesCoordinates: item.verticesCoordinates,
                color: item.color,
                deliveryZoneCircleRange: {
                    measureUnit: item.deliveryZoneCircleRange ? item.deliveryZoneCircleRange.measureUnit : null,
                    startRange: item.deliveryZoneCircleRange ? (item.deliveryZoneCircleRange.startRange || item.deliveryZoneCircleRange.startRange === 0) ? +item.deliveryZoneCircleRange.startRange : null : null,
                    endRange: item.deliveryZoneCircleRange ? item.deliveryZoneCircleRange.endRange ? +item.deliveryZoneCircleRange.endRange : null : null,
                }
            }
            if (currentDeliveryZone.id == deliveryZoneId) {
                if (target !== undefined || target.value !== null || target.value !== '') {

                    if (target.name == 'deliveryChargeInPercentage' || target.name == 'active') {
                        currentDeliveryZone[target.name] = convertCheckBoxValueToBoolean({ target });
                    }

                    if (target.name === 'verticesCoordinates' && target.value === null) {
                        currentDeliveryZone[target.name] = target.value;
                        this.setState({ ...this.state, removeLargeMap: true }, () => {
                            this.setState({ ...this.state, removeLargeMap: false });
                        });
                    }

                    if (target.name === 'measureUnit' || target.name === 'startRange' || target.name === 'endRange') {
                        currentDeliveryZone.deliveryZoneCircleRange[target.name] = target.value;
                    } else {
                        currentDeliveryZone[target.name] = target.value;
                    }
                }

            }
            updatedDeliveryZones.push(currentDeliveryZone)
        })

        return updatedDeliveryZones;
    }

    updateZonesStateOnZoneTypeChange() {
        let updatedDeliveryZones = null;

        // If mapping chosen remove zip codes and circles
        if (this.state.newZoneType === 'MAP_BASED') {
            updatedDeliveryZones = this.state.deliveryZones.map((zone) => {
                zone.zipCodes = '';
                zone.deliveryZoneCircleRange = null;
                zone.active = false;
                return zone;
            });

        } else if (this.state.newZoneType === 'ZIP_CODE_BASED') { // if zipCodes chosen remove map cords and circles

            updatedDeliveryZones = this.state.deliveryZones.map((zone) => {
                zone.verticesCoordinates = [];
                zone.deliveryZoneCircleRange = null;
                zone.active = false;
                return zone;
            });

        } else if (this.state.newZoneType === 'CIRCLE_BASED') { // if circle rule chosen reomve map and zip codes

            updatedDeliveryZones = this.state.deliveryZones.map((zone) => {
                zone.verticesCoordinates = [];
                zone.zipCodes = '';
                zone.active = false;
                return zone;
            });

        }

        this.setState({
            ...this.state,
            deliveryZones: updatedDeliveryZones
        });

    }

    handleZoneTypeUpdate(saveZoneType) {
        // check if we have some data before we try to update the state on zoneTypeChange
        if (this.state.deliveryZones !== undefined && this.state.deliveryZones !== null
            && (this.state.deliveryZones.zipCodes !== '' || this.state.deliveryZones.verticesCoordinates)) {
            this.updateZonesStateOnZoneTypeChange();
        }

        const restaurantId = this.props.match.params.id;
        this.resetLargeMap()
        this.setState({
            ...this.state,
            zoneType: this.state.newZoneType,
        }, () => {
            this.props.updateDeliverySettings(restaurantId, this.state);
            this.setState({ ...this.state, removeLargeMap: true }, () => {
                this.setState({ ...this.state, removeLargeMap: false });
            });
        });

    }

    renderDeliveryTypeZones() {
        const { headerStyle, spaceBetween, typesRowStyle, zeroPadding, deliveryZoneTypeForm, deliveryZoneRadioButtons, containerStyle } = styles;

        if (this.state.zoneType === null || this.state.zoneType === undefined) {
            return (<div></div>);
        }

        let defaultValues = null;
        if (this.state.zoneType !== null) {
            this.state.zoneType === 'MAP_BASED' && (defaultValues = { delivery_zone_type: 'mapping' });
            this.state.zoneType === 'ZIP_CODE_BASED' && (defaultValues = { delivery_zone_type: 'zipCodes' });
            this.state.zoneType === 'CIRCLE_BASED' && (defaultValues = { delivery_zone_type: 'circleRule' });
        }

        let mappingChecked = null;
        (defaultValues.delivery_zone_type === 'mapping') ? mappingChecked = true : mappingChecked = false;

        let zipCodeChecked = null;
        (defaultValues.delivery_zone_type === 'zipCodes') ? zipCodeChecked = true : zipCodeChecked = false;

        let circleRuleChecked = null;
        (defaultValues.delivery_zone_type === 'circleRule') ? circleRuleChecked = true : circleRuleChecked = false;

        return (
            <div style={containerStyle}>
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="map" color="#0288d1" size={20} />
                        <span style={spaceBetween}>{i18n.t('screens:deliveryZoneScreen.deliveryZoneTypes')}</span>
                    </div>
                </Row>
                <Row style={typesRowStyle}>
                    <AvForm model={defaultValues} style={deliveryZoneTypeForm}>
                        <Col sm={12} style={zeroPadding}>
                            <AvForm className='zoneType' inline name="delivery_zone_type" style={{ marginLeft: 15 }}>
                                <AvField label={i18n.t('screens:deliveryZoneScreen.drawMapArea')} style={deliveryZoneRadioButtons} type='radio' name="mapping" value="mapping" checked={mappingChecked} onChange={this.changeDeliveryZoneType} />
                                <AvField label={i18n.t('screens:deliveryZoneScreen.enterZipCodes')} style={deliveryZoneRadioButtons} type='radio' name="zipCodes" value="zipCodes" checked={zipCodeChecked} onChange={this.changeDeliveryZoneType} />
                                <AvField label={i18n.t('screens:deliveryZoneScreen.circleRule')} style={deliveryZoneRadioButtons} type='radio' name="circleRule" value="circleRule" checked={circleRuleChecked} onChange={this.changeDeliveryZoneType} />
                            </AvForm>
                        </Col>
                    </AvForm>
                </Row>
            </div>
        );
    }

    renderDeliveryZone() {
        const { headerStyle, spaceBetween, marginTop, deliveryZoneLabelContainer } = styles;

        return (
            <Col style={deliveryZoneLabelContainer}>
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="location_on" color="#0288d1" size={20} />
                        <span
                            style={spaceBetween}>{i18n.t('screens:deliveryZoneScreen.deliveryZones')}</span>
                    </div>
                </Row>
                <Row style={marginTop}>
                    {this.renderDeliveryZoneContent()}
                </Row>
            </Col>
        );
    }

    renderAddDeliveryZoneBtn() {
        const { saveButton, spaceBetween, rowTopBottomMargins, tooltipColumn, zeroPaddings } = styles;

        const automaticColumnStyleSelect = this.state.displayNewZone ? tooltipColumn : zeroPaddings;
        const isDisabled = this.state.displayNewZone ? true : false;

        return (
            <Row style={rowTopBottomMargins}>
                <Col style={automaticColumnStyleSelect}>
                    <div id="addDeliveryZone">
                        <Button color="primary" sm={12} style={saveButton} disabled={isDisabled} onClick={this.toggleNewDeliveryZone}>
                            <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />
                            <span style={spaceBetween}>{i18n.t('screens:deliveryZoneScreen.addDeliveryZoneBtn')}</span>
                        </Button>
                        <Tooltip placement="top" isOpen={this.state.tooltipOpen} target="addDeliveryZone" disabled={!isDisabled} toggle={this.toggleTooltip}>
                            {i18n.t('screens:deliveryZoneScreen.addDeliveryZoneTooltip')}
                        </Tooltip>
                    </div>
                </Col>
            </Row>
        );
    }

    renderDeliveryZoneContent() {
        const { zeroPaddings } = styles;

        if (!this.state.zoneType === 'ZIP_CODE_BASED') {
            return (
                <Col></Col>
            );
        }

        if ((this.state.zoneType === 'MAP_BASED' || this.state.zoneType === 'CIRCLE_BASED') && this.state.deliveryZones && !this.state.removeLargeMap && this.props.restaurant.address) {

            return (
                <Col style={zeroPaddings}>
                    <Map
                        id="largeMap"
                        onMapLoad={map => {
                            this.setState({ ...this.state, map: map });
                            this.addDeliveryZonesToMap(map);
                        }}
                        height={400}
                    />
                </Col>
            );
        }

    }

    resetLargeMap() {
        this.addDeliveryZonesToMap(null);
    }

    clearMapFromDeliveryZones() {
        // Remove all polygons so we can reset the map and draw the new ones from server
        this.state.polygons.map((polygon) => {
            polygon.setMap(null);
        })
    }

    updateCurrentDeliveryZone(mapDrawed, setDeliveryPartner) {
        let restaurantId = this.props.match.params.id;

        if (this.state.currentDeliveryZone) {

            // If no data is changed set empty object so the guard in the action stops the request
            /*if (this.state.currentDeliveryZone === null) {
                this.setState({
                    ...this.state,
                    currentDeliveryZone: [{}]
                });
            }*/

            if (+this.state.currentDeliveryZone[0].deliveryZoneCircleRange.startRange >= +this.state.currentDeliveryZone[0].deliveryZoneCircleRange.endRange && this.state.currentDeliveryZone[0].deliveryZoneCircleRange.endRange) {
                this.props.dispatchErrorMessage(i18n.t('actions:deliveryZonesActions.createCircleZoneFailure'));
                return;
            }

            if (this.state.zoneType === 'CIRCLE_BASED') {
                mapDrawed = true;
            }

            if (!mapDrawed && this.state.zoneType !== 'ZIP_CODE_BASED') {
                this.props.dispatchErrorMessage(i18n.t('actions:deliveryZonesActions.createDeliveryZoneFailure'));
                return;
            }

            this.props.updateDeliveryZones(restaurantId, this.state.currentDeliveryZone[0], () => {
                let restaurantId = this.props.match.params.id;

                this.props.loadDeliverySettings(restaurantId, () => {
                    this.state.deliveryZones = this.props.deliverySettings.deliveryZones;
                    this.setState({ ...this.state, removeLargeMap: true, currentDeliveryZone: null }, () => {
                        this.setState({ ...this.state, removeLargeMap: false });
                    });
                    this.resetLargeMap();
                });
            }, setDeliveryPartner);
        } else {
            if (this.state.zoneType === 'CIRCLE_BASED') {
                mapDrawed = true;
            }

            if (!mapDrawed && this.state.zoneType !== 'ZIP_CODE_BASED') {
                this.props.dispatchErrorMessage(i18n.t('actions:deliveryZonesActions.createDeliveryZoneFailure'));
                return;
            }

            setDeliveryPartner(undefined, () => this.props.loadDeliverySettings(restaurantId, () => {
                this.state.deliveryZones = this.props.deliverySettings.deliveryZones;
                this.setState({ ...this.state, removeLargeMap: true }, () => {
                    this.setState({ ...this.state, removeLargeMap: false });
                });
                this.resetLargeMap();
            }));
        }
    }

    createNewDeliveryZone(mapDrawed, setDeliveryPartner) {
        if (this.state.zoneType === 'CIRCLE_BASED') {
            mapDrawed = true;
        }

        if ((!mapDrawed && this.state.zoneType !== 'ZIP_CODE_BASED')) {
            this.props.dispatchErrorMessage(i18n.t('actions:deliveryZonesActions.createDeliveryZoneFailure'));
            return;
        }

        if (+this.state.blankDeliveryZone.deliveryZoneCircleRange.startRange >= +this.state.blankDeliveryZone.deliveryZoneCircleRange.endRange && this.state.blankDeliveryZone.deliveryZoneCircleRange.endRange) {
            this.props.dispatchErrorMessage(i18n.t('actions:deliveryZonesActions.createCircleZoneFailure'));
            return;
        }

        let restaurantId = this.props.match.params.id;

        // If we dont have cords or zipCodes do not save the zone
        this.props.updateDeliveryZones(restaurantId, this.state.blankDeliveryZone, () => {
            // TODO is it wrong to reset the state data like that
            this.state.blankDeliveryZone = INITIAL_BLANK_ZONE_STATE;

            let restaurantId = this.props.match.params.id;

            this.props.loadDeliverySettings(restaurantId, () => {
                this.state.deliveryZones = this.props.deliverySettings.deliveryZones;
                this.resetLargeMap();
                this.setState({ ...this.state, removeLargeMap: true }, () => {
                    this.setState({ ...this.state, removeLargeMap: false });
                });
            });
        }, setDeliveryPartner, () => this.toggleNewDeliveryZone());
    }

    deleteDeliveryZone(id) {
        this.toggleItemConfirmationScreen();
    }

    deleteZoneAfterConfirmation(id) {
        let restaurantId = this.props.match.params.id;

        this.props.deleteDeliveryZone(restaurantId, id, () => {

            const restaurantId = this.props.match.params.id;
            this.props.loadDeliverySettings(restaurantId, () => {
                this.state.deliveryZones = this.props.deliverySettings.deliveryZones;
                this.resetLargeMap();
                this.setState({ ...this.state, removeLargeMap: true }, () => {
                    this.setState({ ...this.state, removeLargeMap: false });
                });
            });
        });
    }

    deleteNewDeliveryZone() {

        this.setState({
            displayNewZone: false,
            blankDeliveryZone: {
                name: i18n.t('screens:deliveryZoneScreen.newZone'),
                deliveryTime: '',
                deliveryCharge: '',
                deliveryChargeInPercentage: false,
                minimumOrderAmount: 1,
                maximumOrderAmount: '',
                active: false,
                zipCodes: '',
                verticesCoordinates: null,
                color: 'GRAY'
            }
        });
    }

    renderDeliveryZoneItems() {
        const { listGroupItem } = styles;
        const { deliveryZones } = this.state;

        if (deliveryZones !== undefined && deliveryZones !== null && deliveryZones.length > 0 &&
            this.props.restaurant.currency !== undefined && this.props.restaurant.currency !== null && this.props.restaurant.currency !== ''
            && !this.state.removeLargeMap) {

            const currency = getCurrencySymbol(this.props.restaurant.currency);

            return (
                <ListGroup>
                    {this.renderNewDeliveryZoneItem()}

                    {deliveryZones.map((deliveryZone, i) => {

                        // Get the delivery zones that are not to be displayed
                        let inactiveDeliveryZones = deliveryZones.filter((zone) => {
                            if (zone.id !== deliveryZone.id) return zone;
                        });

                        return (
                            <ListGroupItem key={'listItem' + i} className="noHoverEffect" style={listGroupItem}>
                                <DeliveryZoneItem
                                    key={i}
                                    styles={styles}
                                    restaurant={this.props.restaurant}
                                    deliveryZone={deliveryZone}
                                    inactiveDeliveryZones={inactiveDeliveryZones}
                                    changeDeliveryZoneState={this.changeDeliveryZoneState}
                                    zoneType={this.state.zoneType}
                                    drawCircle={this.drawCircle}
                                    update={this.updateCurrentDeliveryZone}
                                    deleteZone={() => { this.deleteDeliveryZone(deliveryZone.id) }}
                                    deleteZoneAfterConfirmationScreen={() => this.deleteZoneAfterConfirmation(deliveryZone.id)}
                                    itemConfirmationScreenOpened={this.state.itemConfirmationScreenOpened}
                                    toggleItemConfirmationScreen={this.toggleItemConfirmationScreen}
                                    currency={currency}
                                    deliveryProvider={this.props.deliveryProvider}
                                />
                            </ListGroupItem>
                        );
                    })}
                </ListGroup>
            );
        } else {
            return (
                <ListGroup>{this.renderNewDeliveryZoneItem()}</ListGroup>
            );
        }
    }

    renderNewDeliveryZoneItem() {
        const { listGroupItem } = styles;
        const newDeliveryZone = ["index element"];

        const currency = getCurrencySymbol(this.props.restaurant.currency);

        return (
            newDeliveryZone.map(i => {
                if (this.state.displayNewZone) {
                    return (
                        <div>
                            <ListGroupItem key={'newZone' + i} className="noHoverEffect" style={listGroupItem}>
                                <DeliveryZoneItem
                                    styles={styles}
                                    newZone={this.state.displayNewZone}
                                    restaurant={this.props.restaurant}
                                    deliveryZone={this.state.blankDeliveryZone}
                                    inactiveDeliveryZones={this.state.deliveryZones}
                                    changeDeliveryZoneState={this.changeBlankDeliveryZoneState}
                                    zoneType={this.state.zoneType}
                                    drawCircle={this.drawCircle}
                                    hideNewDeliveryZone={() => { this.setState({ ...this.state, displayNewZone: false }) }}
                                    update={this.createNewDeliveryZone}
                                    deleteZone={this.deleteNewDeliveryZone}
                                    currency={currency}
                                    deliveryProvider={this.props.deliveryProvider}
                                />
                            </ListGroupItem>
                            <div className="scroll" ref={(ref) => this.state.scrollToElement = ref}>
                            </div>
                        </div>
                    );
                } else {
                    return <div key={'noNewZone' + i}></div>;
                }
            })
        );
    }

    drawCircle(point, radius, dir, measureUnit, bounds) {
        var d2r = Math.PI / 180; // degrees to radians 
        var r2d = 180 / Math.PI; // radians to degrees 
        var earthsradius = measureUnit === 'mi' ? 3963 : 3963 * 1.609344; // 3963 is the radius of the earth in miles

        var points = 32;

        // find the raidus in lat/lon 
        var rlat = (radius / earthsradius) * r2d;
        var rlng = rlat / Math.cos(point.lat() * d2r);


        var extp = new Array();
        if (dir == 1) {
            var start = 0;
            var end = points + 1
        } // one extra here makes sure we connect the
        else {
            var start = points + 1;
            var end = 0
        }
        for (var i = start; (dir == 1 ? i < end : i > end); i = i + dir) {
            var theta = Math.PI * (i / (points / 2));
            var ey = point.lng() + (rlng * Math.cos(theta)); // center a + radius x * cos(theta) 
            var ex = point.lat() + (rlat * Math.sin(theta)); // center b + radius y * sin(theta) 
            extp.push(new window.google.maps.LatLng(ex, ey));
            bounds.extend(extp[extp.length - 1]);
        }
        // alert(extp.length);
        return extp;
    }

    render() {
        const { containerMargin, containerStyle, errorContainerStyle, errorMessage } = styles;

        let firstRowText = '';
        this.state.zoneType === 'ZIP_CODE_BASED' && (firstRowText = i18n.t('screens:deliveryZoneScreen.msgZipCodesWillBeDeleted'));
        this.state.zoneType === 'MAP_BASED' && (firstRowText = i18n.t('screens:deliveryZoneScreen.msgMapsWillBeDeleted'));
        this.state.zoneType === 'CIRCLE_BASED' && (firstRowText = i18n.t('screens:deliveryZoneScreen.msgCirclesWillBeDeleted'));

        const textData = {
            header: i18n.t('screens:deliveryZoneScreen.msgHeader'),
            firstRow: firstRowText,
            secondRow: i18n.t('screens:deliveryZoneScreen.msgMapsDeleteConfirm')
        };

        let secondCondition = this.props.deliverySettings.preparationTimes !== undefined
            && this.props.deliverySettings.preparationTimes.length > 0;

        if (this.props.deliverySettings.timeSlotBased) {
            secondCondition = this.props.deliverySettings.timeSlots.length;
        }

        this.copyStateFromProps();

        if (this.props.deliverySettings !== undefined && secondCondition) {
            return (
                <div style={containerMargin}>
                    {this.renderDeliveryTypeZones()}

                    <div style={containerStyle}>
                        {this.renderDeliveryZone()}
                        {this.renderAddDeliveryZoneBtn()}
                        {this.renderDeliveryZoneItems()}
                    </div>

                    <DeliveryZoneConfirmationScreen
                        isOpen={this.state.confirmationScreenOpened}
                        onToggle={this.toggleConfirmationScreen}
                        onSave={(params) => { this.handleZoneTypeUpdate(params) }}
                        message={textData}
                        deliveryZone={this.props.deliverySettings}
                    />
                </div>
            );
        } else {

            return (
                <div style={errorContainerStyle} className="errorIcon">
                    <h5 style={errorMessage}>{i18n.t('screens:deliveryZoneScreen.msgSpecifyDeliveryHours')}</h5>
                    <MaterialIcon icon="warning" color="#dbdadb" size={40} />
                </div>
            );
        }

    }
}

const mapStateToProps = (state) => {
    return {
        restaurant: state.restaurant,
        deliverySettings: state.deliverySettings,
        deliveryProvider: state.deliveryProvider
    }
};

export default connect(mapStateToProps, {
    loadDeliverySettings,
    updateDeliverySettings,
    updateDeliveryZones,
    deleteDeliveryZone,
    resetDeliverySettings,
    dispatchErrorMessage,
    loadRestaurant,
    getDeliveryPartners
})(DeliveryZonesScreen);

const styles = {
    cardBody: {
        paddingBottom: 0
    },
    containerMargin: {
        marginLeft: 15
    },
    cardBodyLeftCol: {
        display: 'flex',
        flexDirection: 'column'
    },
    containerStyle: {
        paddingLeft: 30,
        marginBottom: 25,
        paddingBottom: 20,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        paddingTop: 10,
        paddingRight: 30,
        width: '101%'
    },
    headerStyle: {
        paddingLeft: 0,
        paddingRight: 0,
        borderBottom: "1px solid rgb(222, 226, 230)",
        color: '#0288d1',
        width: 299,
    },
    spaceBetween: {
        paddingLeft: 4
    },
    zeroPadding: {
        paddingLeft: 0
    },
    zeroPaddingRight: {
        paddingRight: 0
    },
    zeroPaddings: {
        paddingLeft: 0,
        paddingRight: 0
    },
    avFormGroup: {
        height: 68,
        marginBottom: 0
    },
    avField: {
        width: 80,
        marginRight: 21
    },
    avSelect: {
        width: 130
    },
    areaColorSelect: {
        paddingLeft: 0,
        paddingRight: 0,
        marginLeft: 15
    },
    alignRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0,
        marginBottom: 10
    },
    listGroupItem: {
        border: 'none',
        padding: '0 0 12px 0'
    },
    zipCodesLabel: {
        paddingTop: 10,
        marginBottom: 10
    },
    textArea: {
        height: 312
    },
    spaceBetweenBtns: {
        marginLeft: 10
    },
    secondLabels: {
        paddingTop: 8
    },
    deliveryChargeLabel: {
        padding: '0px 0px 14px 15px'
    },
    checkboxInput: {
        position: "relative",
        margin: 0,
        top: 8
    },
    activeCheckbox: {
        position: "relative",
        margin: 0,
        top: 2
    },
    saveZoneTypeButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    saveButton: {
        float: 'right'
    },
    currencyTypeStyle: {
        paddingRight: 10,
        paddingLeft: 5
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    activeLabel: {
        marginRight: 20,
        paddingTop: 9
    },
    expandMoreIcon: {
        position: 'absolute'
    },
    collapseZindex: {
        zIndex: 10
    },
    expandLessIcon: {
        background: '#f7f7f7'
    },
    marginTop: {
        marginTop: 10
    },
    rowTopBottomMargins: {
        marginTop: 20,
        marginBottom: 20,
        marginRight: 0
    },
    deliveryZoneTypeForm: {
        width: "100%",
        display: 'flex',
        flexDirection: 'row'
    },
    deliveryZoneRadioButtons: {
        marginLeft: 10,
        marginRight: 10
    },
    tooltipColumn: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingLeft: 0,
        paddingRight: 0
    },
    typesRowStyle: {
        marginTop: 10,
        marginBottom: -15
    },
    mapContainer: {
        position: 'relative'
    },
    deleteDrawingIcon: {
        position: 'absolute',
        top: 10,
        right: 'calc(50% - 12px)',
        cursor: 'pointer',
        backgroundColor: '#fff',
        padding: 6,
        boxShadow: '1px 1px 5px #888888',
        borderRadius: 2
    },
    deliveryZoneLabelContainer: {
        position: 'relative',
        right: 11
    },
    errorContainerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #c93a11',
        paddingBottom: 10,
        paddingTop: 60,
        paddingLeft: 15,
        height: 200,
        textAlign: 'center',
    },
    errorMessage: {
        color: "#c3c3c3",
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/DeliveryZonesScreen.js